import {Avatar, CardHeader} from '@mui/material';

export const UserCell = ({
  name,
  picture,
  borderColor,
}: {
  name: string;
  picture?: string;
  borderColor?: string;
}) => {
  return (
    <span>
      <CardHeader
        avatar={
          name && (
            <Avatar
              sx={{
                width: '22px',
                height: '22px',
                border: borderColor ? `1.5px solid ${borderColor}` : 'none',
              }}
              src={picture}
            />
          )
        }
        title={name || '-'}
        sx={{
          height: '20px',
          padding: 0,
          justifyContent: 'flex-start',
          gap: '4px',
          '& .MuiCardHeader-content': {
            flexGrow: 0,
          },
          '& .MuiCardHeader-avatar': {
            margin: 0,
          },
          '& .MuiCardHeader-title': {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '19px',
            letterSpacing: '0.25px',
            textAlign: 'left',
            color: 'var(--dcm-gray)',
          },
        }}
      />
    </span>
  );
};
